/**
 * Default MarkerClusterGroup options.
 * Imported by useLayers when creating clustered layer groups.
 */
import L from 'leaflet';
import { MAP_DEFAULTS } from '../constants/mapDefaults';

/**
 * Returns a fresh options object for L.markerClusterGroup().
 * Accepts a color override so each layer can have its own cluster bubble color.
 * @param {string} color - hex color for the cluster bubble
 * @returns {object}
 */
export function buildClusterOptions(color = '#de520c') {
  return {
    // Performance: add markers in chunks to avoid freezing the browser
    chunkedLoading:         true,
    chunkSize:              MAP_DEFAULTS.chunkSize,
    chunkDelay:             MAP_DEFAULTS.chunkDelay,

    maxClusterRadius:       MAP_DEFAULTS.clusterRadius,
    disableClusteringAtZoom:MAP_DEFAULTS.clusterMaxZoom,
    showCoverageOnHover:    false,
    zoomToBoundsOnClick:    true,
    spiderfyOnMaxZoom:      false,
    removeOutsideVisibleBounds: true,
    animate:                true,

    iconCreateFunction(cluster) {
      const count  = cluster.getChildCount();
      const size   = count < 10 ? 38 : count < 100 ? 44 : 52;
      const radius = size / 2;

      return L.divIcon({
        html: `
          <div class="sarpa-cluster-bubble" style="
            width:${size}px;height:${size}px;border-radius:50%;
            background:${color};
            display:flex;align-items:center;justify-content:center;
            color:#fff;font-weight:700;font-size:${count < 100 ? 13 : 11}px;
            font-family:poppinsmedium,sans-serif;
            box-shadow:0 2px 8px rgba(0,0,0,0.28);
            border:2.5px solid rgba(255,255,255,0.7);
          ">${count}</div>`,
        className:  'sarpa-cluster',
        iconSize:   [size, size],
        iconAnchor: [radius, radius],
      });
    },
  };
}
